(function () {

  'use strict';



  function disableSmoothScrollLock() {

    document.body.classList.remove('smooth-scroll-active');

  }



  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {

    disableSmoothScrollLock();

    return;

  }



  gsap.registerPlugin(ScrollTrigger);



  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const desktopQuery = window.matchMedia('(min-width: 750px)');

  const isDesignMode = document.documentElement.classList.contains('shopify-design-mode');

  const wrapper = document.getElementById('smooth-wrapper');

  const content = document.getElementById('smooth-content');

  let smoother = null;



  function shouldSmooth() {

    return (

      !prefersReducedMotion.matches &&

      !isDesignMode &&

      desktopQuery.matches &&

      wrapper &&

      content &&

      typeof ScrollSmoother !== 'undefined'

    );

  }



  window.ArchiveThreadsGSAP = { gsap, ScrollTrigger, ScrollSmoother: null };



  function refreshScroll() {

    if (smoother) {

      smoother.refresh();

    }

    ScrollTrigger.refresh();

  }



  function watchHeroImages() {

    const images = document.querySelectorAll(

      '.visit-hero-image img, slideshow-component .slideshow__slide:first-child .banner__media > img'

    );

    if (!images.length) return;



    let pending = 0;

    images.forEach((img) => {

      if (img.complete) return;

      pending += 1;

      img.addEventListener(

        'load',

        () => {

          pending -= 1;

          if (pending === 0) refreshScroll();

        },

        { once: true }

      );

    });

  }



  function destroySmoother() {

    if (!smoother) {

      disableSmoothScrollLock();

      return;

    }

    smoother.kill();

    smoother = null;

    window.ArchiveThreadsGSAP.ScrollSmoother = null;

    disableSmoothScrollLock();

    ScrollTrigger.refresh();

  }



  function initSmoother() {

    if (!shouldSmooth() || smoother) return;



    try {

      gsap.registerPlugin(ScrollSmoother);

      smoother = ScrollSmoother.create({

        wrapper: '#smooth-wrapper',

        content: '#smooth-content',

        smooth: 1.2,

        smoothTouch: false,

        effects: false,

        normalizeScroll: {
          allowNestedScroll: true,
          lockAxis: false,
        },

      });

    } catch (error) {

      smoother = null;

      disableSmoothScrollLock();

      return;

    }



    window.ArchiveThreadsGSAP.ScrollSmoother = smoother;

    document.body.classList.add('smooth-scroll-active');

    refreshScroll();

  }



  function syncSmoother() {

    if (shouldSmooth()) {

      initSmoother();

    } else {

      destroySmoother();

    }

  }



  function normalizePath(path) {

    const normalized = path.replace(/\/$/, '');

    return normalized || '/';

  }



  function isSamePageLink(href) {

    try {

      const linkUrl = new URL(href, window.location.href);

      if (linkUrl.origin !== window.location.origin) return false;

      return normalizePath(linkUrl.pathname) === normalizePath(window.location.pathname);

    } catch (error) {

      return false;

    }

  }



  function targetFromHash(hash) {

    if (!hash || hash === '#') return null;

    const id = decodeURIComponent(hash.slice(1));

    return document.getElementById(id);

  }



  function scrollToAnchor(target, smoothScroll) {

    if (!target) return false;

    const reduceMotion = prefersReducedMotion.matches;

    const smootherInstance = window.ArchiveThreadsGSAP && window.ArchiveThreadsGSAP.ScrollSmoother;

    const smooth = Boolean(smoothScroll && !reduceMotion);



    if (smootherInstance && !reduceMotion) {

      smootherInstance.scrollTo(target, smooth, 'top top');

    } else {

      target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });

    }



    return true;

  }



  function handleLocationHash(smoothScroll) {

    const target = targetFromHash(window.location.hash);

    if (!target) return;

    refreshScroll();

    scrollToAnchor(target, smoothScroll);

  }



  function initHashNavigation() {

    document.addEventListener('click', (event) => {

      const anchor = event.target.closest('a[href*="#"]');

      if (!anchor || anchor.target === '_blank' || anchor.hasAttribute('download')) return;

      if (!isSamePageLink(anchor.href)) return;



      const url = new URL(anchor.href, window.location.href);

      const target = targetFromHash(url.hash);

      if (!target) return;



      event.preventDefault();

      if (url.hash !== window.location.hash) {

        history.pushState(null, '', url.hash);

      }

      scrollToAnchor(target, true);

    });



    window.addEventListener('hashchange', () => {

      handleLocationHash(true);

    });

  }



  function boot() {

    syncSmoother();

    watchHeroImages();

    refreshScroll();

    initHashNavigation();

    handleLocationHash(false);

  }



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', boot, { once: true });

  } else {

    boot();

  }



  window.addEventListener('load', function () {

    refreshScroll();

    handleLocationHash(false);

    if (desktopQuery.matches && !smoother) {

      disableSmoothScrollLock();

    }

  }, { once: true });

  desktopQuery.addEventListener('change', syncSmoother);



  if (prefersReducedMotion.matches) {

    return;

  }



  document.querySelectorAll('[data-gsap-fade-in]').forEach((el) => {

    gsap.from(el, {

      opacity: 0,

      y: 16,

      duration: 0.5,

      ease: 'power2.out',

      scrollTrigger: {

        trigger: el,

        start: 'top 88%',

        once: true,

      },

    });

  });

})();


